import { render, staticRenderFns } from "./DirectorShiftsTeachers.vue?vue&type=template&id=4919ee63&lang=pug&"
import script from "./DirectorShiftsTeachers.vue?vue&type=script&lang=js&"
export * from "./DirectorShiftsTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports